<template>
    <div class="container -login">
        <div class="row">
            <div class="col-xs-6 col-xs-offset-4">
                <!-- Login form -->
                <template v-if="!show2FA">
                    <h1 class="form-title">Connexion</h1>
                    <form
                        v-on:submit.prevent="login"
                        id="login-form"
                        class="form-container"
                    >
                        <div class="form-group">
                            <p class="form-input-label">Adresse email</p>
                            <input type="text"
                                   name="email"
                                   v-model="email"
                                   class="form-control"
                                   placeholder="Adresse email"
                                   data-testid="email-input"
                            >
                        </div>
                        <div class="form-group">
                            <p class="form-input-label">Mot de passe</p>
                            <input type="password"
                                   name="password"
                                   v-model="password"
                                   class="form-control"
                                   placeholder="Mot de passe"
                                   data-testid="password-input"
                            >
                        </div>

                        <div class="cta">
                            <button
                                class="btn btn-primary"
                                type="submit"
                                data-testid="login-submit"
                            >
                                <loader v-if="connecting" :inline="true"></loader>
                                SE CONNECTER
                            </button>
                        </div>
                    </form>
                </template>
                 <!-- 2FA step -->
                <template v-else>
                    <!-- Button back to login -->
                    <div>
                        <button
                            class="btn-back"
                            v-on:click="backToLogin"
                            data-testid="login-2fa-back"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M19 12L5 12"
                                    stroke="#3E3F3A"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M11 18L5 12L11 6"
                                    stroke="#3E3F3A"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <span>Retour</span>
                        </button>
                    </div>
                    <form
                        v-on:submit.prevent="confirm2FA"
                        class="form-container-2fa"
                    >
                        <h1 class="form-title">
                            On y est presque !
                        </h1>

                        <p class="form-text">
                            Un code à 6 chiffres vient d'être envoyé à:
                            <b class="unbreakable-line">{{ email }}</b>
                        </p>

                        <p class="form-text">
                            Entrez-le pour finaliser votre connexion.
                        </p>

                        <div class="otp-container">
                            <input
                                v-for="i in 6"
                                class="form-control otp-input"
                                v-bind:class="{ 'error': otpError }"
                                v-bind:name="'otp' + $index"
                                v-model="otpDigits[$index]"
                                type="text"
                                pattern="[0-9]*"
                                inputmode="numeric"
                                placeholder="-"
                                maxlength="1"
                                data-testid="login-2fa-input"
                                v-on:input="onOtpInput($index, $event)"
                                v-on:keydown="onOtpKeydown($index, $event)"
                                v-on:paste="onPaste($event)"
                            />
                        </div>

                        <div
                            v-if="otpError"
                            class="text-error"
                        >
                            Le code n'est pas valide ou a expiré.
                        </div>

                        <div class="cta">
                            <button
                                class="btn btn-primary"
                                type="submit"
                                v-bind:disabled="otpCode.length !== 6 || connecting"
                                data-testid="login-2fa-submit"
                            >
                                <loader v-if="connecting" :inline="true"></loader>
                                Confirmer
                            </button>
                        </div>

                        <div class="form-small-text">
                            Si vous n'avez pas reçu d'email, pensez à regarder vos spams.
                        </div>

                        <div class="form-small-text">
                            <b>Le code qui vous a été envoyé est valable pendant 15 minutes.</b>
                            Passé ce délai, il ne pourra plus être utilisé.
                            Vous devrez vous reconnecter et vous recevrez un autre code.
                        </div>
                    </form>
                </template>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
@import '~src/style/variables';

.container {
    margin-top: @grid-gutter-width;
}

.cta {
    text-align: left;
    margin-top: 40px;
}

.otp-container {
    display: flex;
    gap: 8px;
    justify-content: start;
    margin: 0;
}

.otp-input {
    width: 100%;
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    padding: 16px 8px;
    margin: 40px 0 0;

    &.form-control {
        height: 55px;
        padding: 16px 8px;
    }

    &.error {
        border-color: #CE1616;
    }
}

.form-container {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 0;
    max-width: 320px;
}

.form-container-2fa {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 0;
    max-width: 320px;
}

.form-group {
    display: flex;
    flex-direction: column;
    margin: 20px 0 0;
}

.form-title {
    color: #3E3F3A;
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 0 0 20px;
}

.form-text {
    color: #7A6354;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.form-small-text {
    color: #3E3F3A;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 20px;
}

.form-control {
    padding: 9px 16px;
    height: 40px;
}

.text-error {
    color: #CE1616;
    margin-top: 10px;
}

.form-input-label {
    color: #7A6354;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.unbreakable-line {
    word-break: keep-all;
}

.btn-back {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: none;
    border: none;
    padding: 0;
    color: #3E3F3A;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    &:hover {
        cursor: pointer;
    }
}
</style>

<script type="text/ecmascript-6">
    import api from '../api/core';
    import router from '../router';
    import Loader from '../components/Loader';
    import { manager as msgManager } from '../messages';

    export default {
        components: {
            Loader
        },
        data() {
            return {
                msgManager: msgManager,
                email: '',
                password: '',
                connecting: false,
                show2FA: false,

                // 2FA
                otpDigits: ['', '', '', '', '', ''],
                otpError: false
            };
        },
        computed: {
            otpCode() {
                // Join and keep only digits
                return this.otpDigits.join('').replace(/\D/g, '');
            }
        },
        methods: {
            async login() {
                this.$data.connecting = true;

                try {
                    const res = await api.login(this.email, this.password);

                    // Adjust to your API contract for "2FA required"
                    if (res && res.status === 'ok') {
                        this.$data.show2FA = true;
                        this.$data.connecting = false;
                        this.$data.otpError = false;
                        this.$data.otpDigits = ['', '', '', '', '', ''];
                        this.$nextTick(() => this.focusOtp(0));
                        return;
                    }
                } catch (e) {
                    if (e instanceof Error) {
                        throw e;
                    }

                    this.msgManager.push(
                        '',
                        'Une erreur inconnue s’est produit. Êtes-vous bien connecté à Internet ?',
                        'danger'
                    );
                }

                this.$data.connecting = false;
            },

            async confirm2FA() {
                if (this.otpCode.length !== 6) return;

                this.connecting = true;
                this.otpError = false;

                try {
                    await api.login2fa(this.email, this.otpCode);

                    router.replace({ name: 'home' });
                } catch (e) {
                    if (e && e.error === 'MAX_2FA_ATTEMPTS_REACHED') {
                        this.backToLogin();
                        this.msgManager.push(
                            '',
                            'Vous avez saisi un code erroné à trois reprises. ' +
                            'Veuillez vous reconnecter et nous vous enverrons un nouveau code.',
                            'danger'
                        );
                    } else {
                        // Wrong/expired code
                        this.otpError = true;
                        this.otpDigits = ['', '', '', '', '', ''];
                        this.$nextTick(() => this.focusOtp(0));
                    }
                } finally {
                    this.connecting = false;
                }
            },

            backToLogin() {
                this.show2FA = false;
                this.otpDigits = ['', '', '', '', '', ''];
                this.otpError = false;
                this.email = '';
                this.password = '';
            },

            onOtpInput(index, event) {
                this.otpError = false;

                let val = (this.otpDigits[index] || '').toString();
                // Keep only last digit if multiple typed
                val = val.replace(/\D/g, '').slice(-1);

                this.otpDigits.splice(index, 1, val);

                if (val && index < 5) {
                    this.focusOtp(index + 1);
                }
            },

            onOtpKeydown(index, event) {
                const key = event.key || event.keyCode;

                // Backspace
                if (key === 'Backspace' || key === 8) {
                    if (!this.otpDigits[index] && index > 0) {
                        this.focusOtp(index - 1);
                        this.otpDigits.splice(index - 1, 1, '');
                    }
                } else if (key === 'ArrowLeft' || key === 37) {
                    if (index > 0) this.focusOtp(index - 1);
                } else if (key === 'ArrowRight' || key === 39) {
                    if (index < 5) this.focusOtp(index + 1);
                }
            },

            onPaste(event) {
                event.preventDefault();
                const pasted =
                    (event.clipboardData && event.clipboardData.getData('text')) || '';
                const digits = pasted.replace(/\D/g, '');
                if (digits.length === 6) {
                    this.otpDigits = digits.split('');
                    this.$nextTick(() => this.focusOtp(5));
                }
            },

            focusOtp(index) {
                this.$nextTick(() => {
                    const el = this.$el.querySelector('input[name="otp' + index + '"]');
                    if (el) el.focus();
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// Login.vue?7698fa8a